import React from 'react'
// libs
import { useDispatch } from 'react-redux'
// redux
import { hideModal as hideModalAction } from 'store/reducers/modals'
// hocs
import withAction from 'components/Modals/PlanItems/Action/withAction'
// hooks
import { useModalData } from 'hooks'
// components
import { Tab } from '@mui/material'
import { PlanActionActionsMenu } from 'components/CTAs'
import { LoaderWithOverlay, Scrollbar, Tabs } from 'components/UI'
// view components
import ActionResourcesList from 'components/Modals/PlanItems/Action/MinimizedModal/components/ResourcesList'
import ActionActivitiesList from 'components/Modals/PlanItems/Action/MinimizedModal/components/ActivitiesList'
import ActionReviewsList from 'components/Modals/PlanItems/Action/MinimizedModal/components/ReviewsList'
import CompleteAction from 'components/Modals/PlanItems/Action/MinimizedModal/components/DetailsSection/components/CompleteAction'
import CompleteReviewContainer from 'containers/Review/CompleleReview'
import DetailsSection from 'components/Modals/PlanItems/Action/MinimizedModal/components/DetailsSection'
import FullModalContainer from '../../components/FullModalContainer'
// constants
import { Modals, ENTITIES } from 'constants/index'
// views
import {
  SubHeader,
  ContentWrapper,
  FormWrapper,
  DetailsWrapper,
  FullModalHeader as Header,
  CollapseIcon,
  ActivitiesWrapper
} from 'components/Modals/PlanItems/styles'
// themes
import { CloseIcon } from 'components/UI/Icons'
import { EllipsizedText } from 'themes/views/generic'
// utils
import { safeGetOr } from 'utils/fp'
// context
import { ActionContext } from 'context'

const ActionFullModal = () => {
  const dispatch = useDispatch()

  const {
    hideModal,
    modalData: { width, isOpen }
  } = useModalData({ modalType: Modals.ACTION_FULL_MODAL })

  const { entity, isLoading, plan, update } = React.useContext(ActionContext)

  const [tab, setTab] = React.useState(0)
  const [isReviewExist, setIsReviewExist] = React.useState(false)

  const handleSetIsReviewExist = (value) => setIsReviewExist(value)

  const handleClose = () => {
    dispatch(hideModalAction(Modals.ACTION_MINIMIZED_MODAL))
    dispatch(hideModalAction(Modals.ACTION_FULL_MODAL))
  }

  const handleSetTab = (_, value) => setTab(value)

  const isActionExist = safeGetOr('', 'completionAt')(entity)

  const scrollbarHeight = React.useMemo(() => {
    if (isReviewExist && isActionExist) {
      return 'calc(100% - 164px)'
    }
    if (isReviewExist || isActionExist) {
      return 'calc(100% - 82px)'
    }
    return '100%'
  }, [isReviewExist, isActionExist])

  return (
    <FullModalContainer hideModal={hideModal} isOpen={isOpen} width={width}>
      <LoaderWithOverlay isLoading={isLoading} />
      {!isLoading && (
        <>
          <Header>
            <EllipsizedText style={{ maxWidth: '95%' }}>{entity.description}</EllipsizedText>
            <CollapseIcon onClick={hideModal} />
            <CloseIcon onClick={handleClose} />
          </Header>
          <ContentWrapper>
            <FormWrapper>
              <CompleteAction isFullModal entity={entity} update={update} />
              <CompleteReviewContainer
                entity={{ ...entity, entityType: ENTITIES.PLAN_ACTION }}
                handleOnMount={handleSetIsReviewExist}
                hideModal={hideModal}
                isFullModal
              />
              <Scrollbar style={{ height: scrollbarHeight }}>
                <DetailsSection disableDrag hideModal={hideModal} isFullModal />
              </Scrollbar>
            </FormWrapper>
            <DetailsWrapper>
              <SubHeader>
                {!plan.locked && <PlanActionActionsMenu plan={plan} entity={entity} hideParent={hideModal} />}
                <Tabs value={tab} onChange={handleSetTab} indicatorColor='primary' textColor='primary' variant={null}>
                  <Tab label='Activity' />
                  <Tab label='Resources' />
                  <Tab label='Reviews' />
                </Tabs>
              </SubHeader>
              {tab === 0 && (
                <ActivitiesWrapper>
                  <ActionActivitiesList />
                </ActivitiesWrapper>
              )}
              {tab === 1 && <ActionResourcesList />}
              {tab === 2 && <ActionReviewsList />}
            </DetailsWrapper>
          </ContentWrapper>
        </>
      )}
    </FullModalContainer>
  )
}

export default withAction(ActionFullModal)
